/**
 * 模拟考试卡片
 */
export default {
  difficulty: 'Difficulté',
  mockDuration: 'Durée fictive',
  intro: 'Brève introduction',
}
